<template>
  <div v-if="tip" class="global-tip" :class="tip.position || 'bottom-right'">
    <div class="tip-content">
      <p>{{ tip.message }}</p>
      <button @click="closeTip">&times;</button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    tip() {
      return this.$store.state.globalStore.tip.currentTip
    }
  },
  methods: {
    closeTip() {
      this.$store.commit('clearTip')
    }
  }
}
</script>

<style scoped>
.global-tip {
  position: fixed;
  z-index: 1000;
}

.global-tip.bottom-right {
  bottom: 20px;
  right: 20px;
}

.global-tip.top-center {
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.tip-content {
  background: #333;
  color: white;
  padding: 10px 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.tip-content p {
  margin: 0;
}

.tip-content button {
  background: transparent;
  border: none;
  color: white;
  margin-left: 10px;
  cursor: pointer;
}
</style>